import { Component, OnInit, ViewChild } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { _AbcFileUploaderComponent } from '@barthauer/abc/ui-components';
import { ValueChangedEvent } from 'devextreme/ui/file_uploader';
import { IWizardImportPageComponent } from 'libs/abc/interfaces/core/wizards/import/src/lib/models/config.model';
import { AsciiWizardTransferObject } from '../../models/import.model';
import JSZip from 'jszip';

@Component({
    selector: 'barthauer-setting-shapeselection-page',
    templateUrl: './setting-shapeselection-page.component.html',
    styleUrls: ['./setting-shapeselection-page.component.scss'],
    standalone: false
})
export class SettingShapeselectionPageComponent implements OnInit, IWizardImportPageComponent {
  @ViewChild('fileUploader', { static: true }) fileUploader!: _AbcFileUploaderComponent;
  public res = ResourceSet.Empty;
  selectedZippedShapeFile: File;
  transferObject: object;

  get isValid(): boolean {
    return this.fileUploader.validationStatus == 'valid' && this.selectedZippedShapeFile !== undefined;
  }
  get invalidMessage(): string {
    return this.res.get('InvalidSelectionFile');
  }

  constructor(private resourceManagerService: ResourceManagerService) {}

  async ngOnInit() {
    this.res = await this.resourceManagerService.getResourceSet('basys-interfaces-ascii-import');
  }

  onNext(): void {
    (this.transferObject as AsciiWizardTransferObject).shapeFileZipped = this.selectedZippedShapeFile;
  }

  async onSelectedFileChanged(eventArgs: ValueChangedEvent): Promise<void> {
    var files = eventArgs.value;
    if (files) {
      var file = files[0];
      const ext = this.getFileExtension(file);
      if (ext !== undefined && ext.toUpperCase() === 'CSV') {
        const zip = new JSZip();
        zip.file(file.name, file);
        zip.generateAsync({ type: 'blob' }).then((zippedBlob: BlobPart) => {
          this.selectedZippedShapeFile = new File([zippedBlob], 'uploaded.zip', {
            type: 'application/zip',
          });

          this.updateValidationStatus(file);
        });
      } else {
        this.selectedZippedShapeFile = file;
        this.updateValidationStatus(file);
      }
    }
  }

  private updateValidationStatus(file: File): void {
    if (!this.hasValidFileExtension(file)) {
      this.fileUploader.validationStatus = 'invalid';
    } else {
      this.fileUploader.validationStatus = 'valid';
    }
  }

  private hasValidFileExtension(file: File): boolean {
    let isValid = true;
    const ext = this.getFileExtension(file);
    if (this.fileUploader.allowedFileExtensions !== undefined && this.fileUploader.allowedFileExtensions.length > 0) {
      isValid =
        this.fileUploader.allowedFileExtensions.findIndex(
          (t) => t.toLocaleLowerCase() === '.' + ext.toLocaleLowerCase()
        ) > -1;
    }

    return isValid;
  }

  private getFileExtension(file: File): string {
    const fileName = file.name;
    const parts = fileName.split('.');

    if (parts.length > 1) {
      return parts[parts.length - 1];
    } else {
      return '';
    }
  }
}
